// import React, { useEffect, useRef, useState } from "react";
// import { useAppDispatch, useAppSelector } from "../../app/hooks";
// import { useNavigate } from "react-router";
// import * as Yup from "yup";
// import { useFormik } from "formik";
// import { generateOTP, userLogin, userSignup } from "./services/login.services";
// import { FaEdit } from "react-icons/fa";
// import {
//   getBrowserName,
//   getDeviceId,
//   getDeviceType,
//   getSessionId,
// } from "../../_helpers/storageUtils";

// const Login = () => {
//   const dispatch = useAppDispatch();
//   const loading = useAppSelector((state) => state.login.loading);
//   const [showOTP, setShowOTP] = useState(false);
//   const [isOTPButtonClicked, setIsOTPButtonClicked] = useState(false);
//   const [isButtonDisabled, setIsButtonDisabled] = useState(true);
//   const [timer, setTimer] = useState(0);
//   const [isSignup, setIsSignup] = useState(false); // New state for signup/login toggle

//   const deviceId = getDeviceId();
//   const deviceType = getDeviceType();
//   const sessionId = getSessionId();
//   const browser = getBrowserName();

//   useEffect(() => {
//     if (timer > 0) {
//       const countdown = setTimeout(() => setTimer(timer - 1), 1000);
//       return () => clearTimeout(countdown);
//     } else {
//       setIsButtonDisabled(false);
//     }
//   }, [timer]);

//   const [otp, setOtp] = useState(new Array(4).fill(""));
//   const inputRef = useRef<any>([]);
//   const closeBtnRef = useRef<any>(null);

//   useEffect(() => {
//     // Focus the first input on mount
//     inputRef?.current[0]?.focus();
//   }, []);

//   const handleChange = (element: any, index: number) => {
//     if (isNaN(element.value)) return false;

//     const newOtp = [
//       ...otp.map((d, idx) => (idx === index ? element.value : d)),
//     ];
//     setOtp(newOtp);

//     // Focus next input if the current input is not empty
//     if (element.value !== "" && element.nextSibling) {
//       element.nextSibling.focus();
//     }

//     if (newOtp.every((char) => char !== "")) {
//       formik.setFieldValue("otp", newOtp.join(""));
//       formik.handleSubmit();
//     }
//   };

//   const handleKeyDown = (element: any, index: number, e: any) => {
//     if (e.key === "Backspace") {
//       if (element.value === "" && index > 0) {
//         // Move focus to previous input
//         inputRef.current[index - 1].focus();
//         e.preventDefault();
//       } else {
//         setOtp([...otp.map((d, idx) => (idx === index ? "" : d))]);
//       }
//     } else if (e.key === "ArrowLeft") {
//       if (index > 0) {
//         // Move focus to previous input
//         inputRef.current[index - 1].focus();
//       }
//     } else if (e.key === "ArrowRight") {
//       if (index < otp.length - 1) {
//         // Move focus to next input
//         inputRef.current[index + 1].focus();
//       }
//     }
//   };

//   const handlePaste = (e: any) => {
//     const pasteData = e.clipboardData.getData("text").split("");

//     // Ensure pasted data is numeric and within the OTP length
//     if (pasteData.every((char: any) => !isNaN(char))) {
//       const newOtp = [...otp];
//       pasteData.slice(0, otp.length).forEach((char: any, i: number) => {
//         newOtp[i] = char;
//       });
//       setOtp(newOtp);

//       // Focus on the last pasted input field
//       inputRef.current[Math.min(pasteData.length, otp.length) - 1].focus();
//       if (newOtp.every((char) => char !== "")) {
//         formik.setFieldValue("otp", newOtp.join(""));
//         formik.handleSubmit();
//       }
//     }
//   };

//   const loginValidationSchema = Yup.object({
//     mobile_no: Yup.string()
//       .required("Mobile number is required")
//       .matches(/^[0-9]{10}$/, "Mobile number is not valid"),
//   });

//   const signupValidationSchema = Yup.object({
//     first_name: Yup.string()
//       .required("First name is required")
//       .min(2, "First name must be at least 2 characters"),
//     last_name: Yup.string()
//       .required("Last name is required")
//       .min(2, "Last name must be at least 2 characters"),
//     email_id: Yup.string()
//       .required("Email is required")
//       .email("Please enter a valid email address"),
//     // date_of_birth: Yup.string().required("Date of birth is required"),
//     // gender: Yup.number().required("Please select your gender"),
//     mobile_no: Yup.string()
//       .required("Mobile number is required")
//       .matches(/^[0-9]{10}$/, "Mobile number is not valid"),
//   });

//   const formik: any = useFormik({
//     initialValues: {
//       mobile_no: "",
//       otp: "",
//       first_name: "",
//       last_name: "",
//       email_id: "",
//       // date_of_birth: "",
//       // gender: "",
//     },
//     validateOnBlur: true,
//     validationSchema: isSignup ? signupValidationSchema : loginValidationSchema,
//     onSubmit: async (values, { setSubmitting, resetForm }) => {
//       if (isOTPButtonClicked) {
//         setIsOTPButtonClicked(false);

//         if (isSignup) {
//           const signupPayload = {
//             first_name: values.first_name,
//             last_name: values.last_name,
//             // date_of_birth: values.date_of_birth,
//             // gender: parseInt(values.gender),
//             mobile_no: values.mobile_no?.toString(),
//             email_id: values.email_id,
//             browser_version: browser,
//             device_id: deviceId,
//             device_type: deviceType,
//             session_id: sessionId,
//           };
//           const signupResponse = await dispatch(userSignup(signupPayload));
//           if (signupResponse.meta.requestStatus === "fulfilled") {
//             setShowOTP(true);
//             setTimer(30);
//             setIsButtonDisabled(true);
//           }
//         } else {
//           // For login: Generate OTP first
//           const otpResponse = await dispatch(
//             generateOTP(`${values.mobile_no}`)
//           );
//           if (otpResponse.meta.requestStatus === "fulfilled") {
//             setShowOTP(true);
//             setTimer(30);
//             setIsButtonDisabled(true);
//           }
//         }
//       } else {
//         // Both signup and login use the same login API after OTP verification
//         const payload = {
//           mobile_no: `${values?.mobile_no}`,
//           otp: values?.otp,
//           device_id: deviceId,
//           device_type: deviceType,
//           session_id: sessionId,
//           browser_version: browser,
//         };
//         const response = await dispatch(userLogin(payload));
//         if (response.meta.requestStatus === "fulfilled") {
//           if (closeBtnRef.current) {
//             closeBtnRef.current.click();
//           }
//           setSubmitting(false);
//           resetForm();
//         }
//       }
//     },
//   });

//   const handleGenerateOTP = async (mobileno: any) => {
//     const response = await dispatch(generateOTP(`${mobileno}`));
//     if (response.meta.requestStatus === "fulfilled") {
//       setShowOTP(true);
//       setTimer(30);
//       setIsButtonDisabled(true);
//     }
//   };

//   const handleModeSwitch = () => {
//     setIsSignup(!isSignup);
//     setShowOTP(false);
//     setOtp(new Array(4).fill(""));
//     formik.resetForm();
//   };

//   const resetModal = () => {
//     setOtp(new Array(4).fill(""));
//     formik.resetForm();
//     setShowOTP(false);
//     setIsSignup(false);
//   };

//   const isFormValid = () => {
//     if (isSignup) {
//       return (
//         formik.values.mobile_no?.toString()?.length === 10 &&
//         formik.values.first_name &&
//         formik.values.last_name &&
//         formik.values.email_id &&
//         // formik.values.date_of_birth &&
//         // formik.values.gender &&
//         !formik.errors.mobile_no &&
//         !formik.errors.first_name &&
//         !formik.errors.last_name &&
//         !formik.errors.email_id
//         // !formik.errors.date_of_birth &&
//         // !formik.errors.gender
//       );
//     }
//     return (
//       !formik.errors.mobile_no &&
//       formik.values.mobile_no?.toString()?.length === 10
//     );
//   };

//   return (
//     <div
//       className="modal fade login-modal"
//       id="loginModal"
//       tabIndex={-1}
//       aria-labelledby="loginModalLabel"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog">
//         <div className="modal-left">
//           <div className="sc-dtInlm eCzTrX">
//             <p className="sc-kOPcWz fCDhNF">FLAT 12% OFF*</p>
//             <p className="sc-cWSHoV bsLsTf">on your first Flight booking</p>
//             <p className="sc-eBMEME rhNIm">
//               <span className="empty">Use Coupon</span>
//               <span className="fill">BIGSMILE</span>
//             </p>
//           </div>
//         </div>
//         <form
//           onSubmit={(e) => formik.handleSubmit(e)}
//           className={`modal-content ${showOTP ? "open" : ""}`}
//         >
//           <button
//             type="button"
//             className="btn-close"
//             data-bs-dismiss="modal"
//             aria-label="Close"
//             ref={closeBtnRef}
//             onClick={resetModal}
//           ></button>

//           {/* Form Container with Animation */}
//           <div className="form-container">
//             {/* Login/Signup Form */}
//             <div className={`form-slide ${showOTP ? "slide-left" : ""}`}>
//               <div className="modal-header">
//                 <h3>{isSignup ? "Sign Up" : "Login"}</h3>
//               </div>

//               <div className="half-modal">
//                 <div className="modal-form">
//                   {/* Signup Fields */}
//                   {isSignup && (
//                     <>
//                       <div className="form-row">
//                         <div className="modal-body half-width">
//                           <span className="loginCont__label">First Name</span>
//                           <input
//                             className="loginCont__input"
//                             type="text"
//                             name="first_name"
//                             onChange={formik.handleChange}
//                             onBlur={formik.handleBlur}
//                             value={formik.values?.first_name}
//                             placeholder="Enter first name"
//                           />
//                         </div>
//                         <div className="modal-body half-width">
//                           <span className="loginCont__label">Last Name</span>
//                           <input
//                             className="loginCont__input"
//                             type="text"
//                             name="last_name"
//                             onChange={formik.handleChange}
//                             onBlur={formik.handleBlur}
//                             value={formik.values?.last_name}
//                             placeholder="Enter last name"
//                           />
//                         </div>
//                       </div>

//                       <div className="modal-body">
//                         <span className="loginCont__label">Email Address</span>
//                         <input
//                           className="loginCont__input full-width"
//                           type="email"
//                           name="email_id"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           value={formik.values?.email_id}
//                           placeholder="Enter email address"
//                         />
//                       </div>

//                       {/* <div className="form-row">
//                         <div className="modal-body half-width">
//                           <span className="loginCont__label">
//                             Date of Birth
//                           </span>
//                           <input
//                             className="loginCont__input"
//                             type="date"
//                             name="date_of_birth"
//                             onChange={formik.handleChange}
//                             onBlur={formik.handleBlur}
//                             value={formik.values?.date_of_birth}
//                           />
//                         </div>
//                         <div className="modal-body half-width">
//                           <span className="loginCont__label">Gender</span>
//                           <select
//                             className="loginCont__input"
//                             name="gender"
//                             onChange={formik.handleChange}
//                             onBlur={formik.handleBlur}
//                             value={formik.values?.gender}
//                           >
//                             <option value="">Select Gender</option>
//                             <option value="1">Male</option>
//                             <option value="2">Female</option>
//                             <option value="3">Other</option>
//                           </select>
//                         </div>
//                       </div> */}
//                     </>
//                   )}

//                   {/* Mobile Number Field */}
//                   <div className="modal-body">
//                     <span className="loginCont__label">
//                       Enter your Mobile Number
//                     </span>
//                     <span className="loginCont__code">+91</span>
//                     <input
//                       className="loginCont__input"
//                       type="number"
//                       name="mobile_no"
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values?.mobile_no}
//                       onInput={(e: any) => {
//                         return (e.target.value = Math.max(
//                           0,
//                           parseInt(e.target.value)
//                         )
//                           .toString()
//                           .slice(0, 10));
//                       }}
//                     />
//                   </div>
//                 </div>

//                 {/* <button
//                   className="sc-dhKdcB cYwnDu"
//                   disabled={!isFormValid()}
//                   type="submit"
//                   onClick={() => setIsOTPButtonClicked(true)}
//                 >
//                   Continue
//                 </button> */}

//                 <button
//                   className="sc-dhKdcB cYwnDu disabled d-flex justify-content-center align-items-center"
//                   disabled={!isFormValid() || loading}
//                   type="submit"
//                   onClick={() => setIsOTPButtonClicked(true)}
//                 >
//                   {loading ? (
//                     <div
//                       className="spinner-border text-light"
//                       role="status"
//                       style={{ width: 27, height: 27 }}
//                     >
//                       <span className="sr-only"></span>
//                     </div>
//                   ) : (
//                     "Continue"
//                   )}
//                 </button>

//                 <div className="mode-switch">
//                   <span>
//                     {isSignup
//                       ? "Already have an account?"
//                       : "Don't have an account?"}
//                   </span>
//                   <button
//                     type="button"
//                     className="switch-btn"
//                     onClick={handleModeSwitch}
//                   >
//                     {isSignup ? "Login" : "Sign Up"}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* OTP Verification Form */}
//             <div
//               className={`form-slide otp-slide ${
//                 showOTP ? "slide-in" : "slide-right"
//               }`}
//             >
//               <div className="modal-header">
//                 <h3>Verify OTP</h3>
//               </div>
//               <div className="gxPBXm">
//                 <span>{`Enter 4 digit OTP sent to ${formik.values.mobile_no}`}</span>
//                 <FaEdit
//                   className="btn-edit"
//                   onClick={() => {
//                     setShowOTP(false);
//                     setOtp(new Array(4).fill(""));
//                   }}
//                 />
//               </div>
//               <div className="half-modal">
//                 <div className="modal-form">
//                   <div className="verifyOtpCont__otpCont">
//                     {otp.map((e, index) => {
//                       return (
//                         <input
//                           className="verifyOtpCont__otpFiled "
//                           type="text"
//                           name="otp"
//                           maxLength={1}
//                           key={index}
//                           onPaste={handlePaste}
//                           style={{ width: "1em", textAlign: "center" }}
//                           value={e}
//                           ref={(el) => (inputRef.current[index] = el)}
//                           onChange={(e) => handleChange(e.target, index)}
//                           onKeyDown={(e) => handleKeyDown(e.target, index, e)}
//                           disabled={loading}
//                         />
//                       );
//                     })}
//                   </div>
//                   {/* <div className="verifyOtpCont__message"></div>  */}
//                   {showOTP && (
//                     <div className="sc-dLMFU rClTI">
//                       <a
//                         className={`forget-btn ${
//                           isButtonDisabled ? "forget-btn-disabled" : ""
//                         }`}
//                         href="javascript:void(0)"
//                         onClick={() =>
//                           !isButtonDisabled &&
//                           handleGenerateOTP(formik.values.mobile_no)
//                         }
//                       >
//                         Didn't Receive OTP?{" "}
//                         {isButtonDisabled
//                           ? `Wait ${timer} seconds`
//                           : "Resend OTP"}
//                       </a>
//                     </div>
//                   )}
//                   <p data-id="terms-condition" className="sc-kpDqfm jFZtLs">
//                     I agree to receive critical messages such as OTP, booking
//                     details on WhatsApp.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
// import { useNavigate } from "react-router";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  generateOTP,
  userLogin,
  userLoginWithGoogle,
  userSignup,
  // googleLogin,
} from "./services/login.services";
import { FaEdit } from "react-icons/fa";
import { GoogleLogin } from "@react-oauth/google";
import {
  getBrowserName,
  getDeviceId,
  getDeviceType,
  getSessionId,
} from "../../_helpers/storageUtils";
// import { jwtDecode } from "jwt-decode";

const Login = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.login.loading);
  const googleLoading = useAppSelector((state) => state.login.googleLoading);
  const [showOTP, setShowOTP] = useState(false);
  const [isOTPButtonClicked, setIsOTPButtonClicked] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [timer, setTimer] = useState(0);
  const [isSignup, setIsSignup] = useState(false);

  const deviceId = getDeviceId();
  const deviceType = getDeviceType();
  const sessionId = getSessionId();
  const browser = getBrowserName();

  useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    } else {
      setIsButtonDisabled(false);
    }
  }, [timer]);

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const inputRef = useRef<any>([]);
  const closeBtnRef = useRef<any>(null);

  useEffect(() => {
    inputRef?.current[0]?.focus();
  }, []);

  const handleChange = (element: any, index: number) => {
    if (isNaN(element.value)) return false;

    const newOtp = [
      ...otp.map((d, idx) => (idx === index ? element.value : d)),
    ];
    setOtp(newOtp);

    if (element.value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }

    if (newOtp.every((char) => char !== "")) {
      formik.setFieldValue("otp", newOtp.join(""));
      formik.handleSubmit();
    }
  };

  const handleKeyDown = (element: any, index: number, e: any) => {
    if (e.key === "Backspace") {
      if (element.value === "" && index > 0) {
        inputRef.current[index - 1].focus();
        e.preventDefault();
      } else {
        setOtp([...otp.map((d, idx) => (idx === index ? "" : d))]);
      }
    } else if (e.key === "ArrowLeft") {
      if (index > 0) {
        inputRef.current[index - 1].focus();
      }
    } else if (e.key === "ArrowRight") {
      if (index < otp.length - 1) {
        inputRef.current[index + 1].focus();
      }
    }
  };

  const handlePaste = (e: any) => {
    const pasteData = e.clipboardData.getData("text").split("");

    if (pasteData.every((char: any) => !isNaN(char))) {
      const newOtp = [...otp];
      pasteData.slice(0, otp.length).forEach((char: any, i: number) => {
        newOtp[i] = char;
      });
      setOtp(newOtp);

      inputRef.current[Math.min(pasteData.length, otp.length) - 1].focus();
      if (newOtp.every((char) => char !== "")) {
        formik.setFieldValue("otp", newOtp.join(""));
        formik.handleSubmit();
      }
    }
  };

  const handleGoogleLogin = async (credentialResponse: any) => {
    // setGoogleLoading(true);
    try {
      const payload = {
        google_token: credentialResponse.credential,
        device_id: deviceId,
        device_type: deviceType,
        session_id: sessionId,
        browser_version: browser,
      };
      // const decodeToken = (token) => {
      // try {
      //   const decoded = jwtDecode(credentialResponse.credential);
      //   console.log("Decoded token:", decoded);
      //   return decoded;
      // } catch (error) {
      //   console.error("Invalid token:", error);
      //   return null;
      // }
      // };

      const response = await dispatch(userLoginWithGoogle(payload));
      if (response.meta.requestStatus === "fulfilled") {
        if (closeBtnRef.current) {
          closeBtnRef.current.click();
        }
      }
    } catch (error) {
      console.error("Google login failed:", error);
    } finally {
      // setGoogleLoading(false);
    }
  };

  const loginValidationSchema = Yup.object({
    mobile_no: Yup.string()
      .required("Mobile number is required")
      .matches(/^[0-9]{10}$/, "Mobile number is not valid"),
  });

  const signupValidationSchema = Yup.object({
    first_name: Yup.string()
      .required("First name is required")
      .min(2, "First name must be at least 2 characters"),
    last_name: Yup.string()
      .required("Last name is required")
      .min(2, "Last name must be at least 2 characters"),
    email_id: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email address"),
    mobile_no: Yup.string()
      .required("Mobile number is required")
      .matches(/^[0-9]{10}$/, "Mobile number is not valid"),
  });

  const formik: any = useFormik({
    initialValues: {
      mobile_no: "",
      otp: "",
      first_name: "",
      last_name: "",
      email_id: "",
    },
    validateOnBlur: true,
    validationSchema: isSignup ? signupValidationSchema : loginValidationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      if (isOTPButtonClicked) {
        setIsOTPButtonClicked(false);

        if (isSignup) {
          const signupPayload = {
            first_name: values.first_name,
            last_name: values.last_name,
            mobile_no: values.mobile_no?.toString(),
            email_id: values.email_id,
            browser_version: browser,
            device_id: deviceId,
            device_type: deviceType,
            session_id: sessionId,
          };
          const signupResponse = await dispatch(userSignup(signupPayload));
          if (signupResponse.meta.requestStatus === "fulfilled") {
            setShowOTP(true);
            setTimer(30);
            setIsButtonDisabled(true);
          }
        } else {
          const otpResponse = await dispatch(
            generateOTP(`${values.mobile_no}`)
          );
          if (otpResponse.meta.requestStatus === "fulfilled") {
            setShowOTP(true);
            setTimer(30);
            setIsButtonDisabled(true);
          }
        }
      } else {
        const payload = {
          mobile_no: `${values?.mobile_no}`,
          otp: values?.otp,
          device_id: deviceId,
          device_type: deviceType,
          session_id: sessionId,
          browser_version: browser,
        };
        const response = await dispatch(userLogin(payload));
        if (response.meta.requestStatus === "fulfilled") {
          if (closeBtnRef.current) {
            closeBtnRef.current.click();
          }
          setSubmitting(false);
          resetForm();
        }
      }
    },
  });

  const handleGenerateOTP = async (mobileno: any) => {
    const response = await dispatch(generateOTP(`${mobileno}`));
    if (response.meta.requestStatus === "fulfilled") {
      setShowOTP(true);
      setTimer(30);
      setIsButtonDisabled(true);
    }
  };

  const handleModeSwitch = () => {
    setIsSignup(!isSignup);
    setShowOTP(false);
    setOtp(new Array(4).fill(""));
    formik.resetForm();
  };

  const resetModal = () => {
    setOtp(new Array(4).fill(""));
    formik.resetForm();
    setShowOTP(false);
    setIsSignup(false);
  };

  const isFormValid = () => {
    if (isSignup) {
      return (
        formik.values.mobile_no?.toString()?.length === 10 &&
        formik.values.first_name &&
        formik.values.last_name &&
        formik.values.email_id &&
        !formik.errors.mobile_no &&
        !formik.errors.first_name &&
        !formik.errors.last_name &&
        !formik.errors.email_id
      );
    }
    return (
      !formik.errors.mobile_no &&
      formik.values.mobile_no?.toString()?.length === 10
    );
  };

  return (
    <div
      className="modal fade login-modal"
      id="loginModal"
      tabIndex={-1}
      aria-labelledby="loginModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-left">
          <div className="sc-dtInlm eCzTrX">
            <p className="sc-kOPcWz fCDhNF">FLAT 12% OFF*</p>
            <p className="sc-cWSHoV bsLsTf">on your first Flight booking</p>
            <p className="sc-eBMEME rhNIm">
              <span className="empty">Use Coupon</span>
              <span className="fill">BIGSMILE</span>
            </p>
          </div>
        </div>
        <form
          onSubmit={(e) => formik.handleSubmit(e)}
          className={`modal-content ${showOTP ? "open" : ""}`}
        >
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref={closeBtnRef}
            onClick={resetModal}
          ></button>

          {/* Form Container with Animation */}
          <div className="form-container">
            {/* Login/Signup Form */}
            <div className={`form-slide ${showOTP ? "slide-left" : ""}`}>
              <div className="modal-header">
                <h3>{isSignup ? "Sign Up" : "Login"}</h3>
              </div>

              <div className="half-modal">
                <div className="modal-form">
                  {/* Signup Fields */}
                  {isSignup && (
                    <>
                      <div className="form-row">
                        <div className="modal-body half-width">
                          <span className="loginCont__label">First Name</span>
                          <input
                            className="loginCont__input"
                            type="text"
                            name="first_name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values?.first_name}
                            placeholder="Enter first name"
                          />
                        </div>
                        <div className="modal-body half-width">
                          <span className="loginCont__label">Last Name</span>
                          <input
                            className="loginCont__input"
                            type="text"
                            name="last_name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values?.last_name}
                            placeholder="Enter last name"
                          />
                        </div>
                      </div>

                      <div className="modal-body">
                        <span className="loginCont__label">Email Address</span>
                        <input
                          className="loginCont__input full-width"
                          type="email"
                          name="email_id"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values?.email_id}
                          placeholder="Enter email address"
                        />
                      </div>
                    </>
                  )}

                  {/* Mobile Number Field */}
                  <div className="modal-body">
                    <span className="loginCont__label">
                      Enter your Mobile Number
                    </span>
                    <span className="loginCont__code">+91</span>
                    <input
                      className="loginCont__input"
                      type="number"
                      name="mobile_no"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values?.mobile_no}
                      onInput={(e: any) => {
                        return (e.target.value = Math.max(
                          0,
                          parseInt(e.target.value)
                        )
                          .toString()
                          .slice(0, 10));
                      }}
                    />
                  </div>
                </div>

                {/* Google Login Button */}
                {isSignup ? (
                  <div className="d-flex gap-2 align-items-center">
                    <button
                      className="sc-dhKdcB cYwnDu disabled d-flex justify-content-center align-items-center signup-continue-btn"
                      disabled={!isFormValid() || loading}
                      type="submit"
                      onClick={() => setIsOTPButtonClicked(true)}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                          style={{ width: 27, height: 27 }}
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Continue"
                      )}
                    </button>
                    <div className="">
                      <span>OR</span>
                    </div>
                    <div className="google-login-container">
                      <div className="position-relative">
                        <GoogleLogin
                          onSuccess={handleGoogleLogin}
                          onError={() => {
                            console.log("Google Login Failed");
                          }}
                          useOneTap={false}
                          shape="rectangular"
                          size="large"
                          text="continue_with"
                          width="100%"
                        />

                        {googleLoading && (
                          <div className="text-center google-loading-spinner">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <button
                      className="sc-dhKdcB cYwnDu disabled d-flex justify-content-center align-items-center"
                      disabled={!isFormValid() || loading}
                      type="submit"
                      onClick={() => setIsOTPButtonClicked(true)}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                          style={{ width: 27, height: 27 }}
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Continue"
                      )}
                    </button>
                    <div className="google-login-container">
                      <div className="divider">
                        <span>OR</span>
                      </div>
                      <div className="position-relative">
                        <GoogleLogin
                          onSuccess={handleGoogleLogin}
                          onError={() => {
                            console.log("Google Login Failed");
                          }}
                          useOneTap={false}
                          shape="rectangular"
                          size="large"
                          text="continue_with"
                          width="100%"
                        />
                        {googleLoading && (
                          <div className="text-center google-loading-spinner">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                <div className="mode-switch">
                  <span>
                    {isSignup
                      ? "Already have an account?"
                      : "Don't have an account?"}
                  </span>
                  <button
                    type="button"
                    className="switch-btn"
                    onClick={handleModeSwitch}
                  >
                    {isSignup ? "Login" : "Sign Up"}
                  </button>
                </div>
              </div>
            </div>

            {/* OTP Verification Form */}
            <div
              className={`form-slide otp-slide ${
                showOTP ? "slide-in" : "slide-right"
              }`}
            >
              <div className="modal-header">
                <h3>Verify OTP</h3>
              </div>
              <div className="gxPBXm">
                <span>{`Enter 4 digit OTP sent to ${formik.values.mobile_no}`}</span>
                <FaEdit
                  className="btn-edit"
                  onClick={() => {
                    setShowOTP(false);
                    setOtp(new Array(4).fill(""));
                  }}
                />
              </div>
              <div className="half-modal">
                <div className="modal-form">
                  <div className="verifyOtpCont__otpCont">
                    {otp.map((e, index) => {
                      return (
                        <input
                          className="verifyOtpCont__otpFiled "
                          type="text"
                          name="otp"
                          maxLength={1}
                          key={index}
                          onPaste={handlePaste}
                          style={{ width: "1em", textAlign: "center" }}
                          value={e}
                          ref={(el) => (inputRef.current[index] = el)}
                          onChange={(e) => handleChange(e.target, index)}
                          onKeyDown={(e) => handleKeyDown(e.target, index, e)}
                          disabled={loading}
                        />
                      );
                    })}
                  </div>
                  {showOTP && (
                    <div className="sc-dLMFU rClTI">
                      <a
                        className={`forget-btn ${
                          isButtonDisabled ? "forget-btn-disabled" : ""
                        }`}
                        href="javascript:void(0)"
                        onClick={() =>
                          !isButtonDisabled &&
                          handleGenerateOTP(formik.values.mobile_no)
                        }
                      >
                        Didn't Receive OTP?{" "}
                        {isButtonDisabled
                          ? `Wait ${timer} seconds`
                          : "Resend OTP"}
                      </a>
                    </div>
                  )}
                  <p data-id="terms-condition" className="sc-kpDqfm jFZtLs">
                    I agree to receive critical messages such as OTP, booking
                    details on WhatsApp.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
